import { render, staticRenderFns } from "./CategoryManager.vue?vue&type=template&id=22d2bcac&scoped=true"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"
import style0 from "./CategoryManager.vue?vue&type=style&index=0&id=22d2bcac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2bcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d2bcac')) {
      api.createRecord('22d2bcac', component.options)
    } else {
      api.reload('22d2bcac', component.options)
    }
    module.hot.accept("./CategoryManager.vue?vue&type=template&id=22d2bcac&scoped=true", function () {
      api.rerender('22d2bcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/components/CategoryManager.vue"
export default component.exports